let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("buLVI")).then(() => parcelRequire('kel6P'));